import React from 'react';

function Home() {
  return (
    <>
      <div className="welcome">
        <h1>Welcome to Our Page</h1>
        <p>
          Lorem Ipsum è un testo segnaposto utilizzato nel
          settore della tipografia e della stampa. Lorem Ipsum
          è considerato il testo segnaposto standard sin dal
          sedicesimo secolo, quando un anonimo tipografo prese
          una cassetta di caratteri e li assemblò per preparare
          un testo campione. È sopravvissuto non solo a più di
          cinque secoli, ma anche al passaggio alla
          videoimpaginazione, pervenendoci sostanzialmente inalterato.
        </p>
        <p>
          Lorem Ipsum è un testo segnaposto utilizzato nel
          settore della tipografia e della stampa. Lorem Ipsum
          è considerato il testo segnaposto standard sin dal
          sedicesimo secolo, quando un anonimo tipografo prese
          una cassetta di caratteri e li assemblò per preparare
          un testo campione. È sopravvissuto non solo a più di
          cinque secoli, ma anche al passaggio alla
          videoimpaginazione, pervenendoci sostanzialmente inalterato.
        </p>
        <p>
          Lorem Ipsum è un testo segnaposto utilizzato nel
          settore della tipografia e della stampa. Lorem Ipsum
          è considerato il testo segnaposto standard sin dal
          sedicesimo secolo, quando un anonimo tipografo prese
          una cassetta di caratteri e li assemblò per preparare
          un testo campione. È sopravvissuto non solo a più di
          cinque secoli, ma anche al passaggio alla
          videoimpaginazione, pervenendoci sostanzialmente inalterato.
        </p>
      </div>
    </>
  );
}

export default Home;
